const UTILS = {
    async PromisesSequential(PromiseArr) {
      let res = []
      for (let i = 0; i < PromiseArr.length; i++) {
        res.push(await PromiseArr[i])
      }
      return res
    },
    ConvertStringToHTML(str) {
      let parser = new DOMParser()
      let doc = parser.parseFromString(str, 'text/html')
      return doc.body
    },
    ConvertStringToJS(str) {
      var script = document.createElement("script")
      script.text = str
      document.head.appendChild(script).parentNode.removeChild(script)
    },
    ObserveIntersection(elementSelector, config, callback) {
      let observer = new IntersectionObserver(callback, config);
      let node = typeof elementSelector == 'string' ? document.querySelector(elementSelector) : elementSelector
      observer.observe(node, config);  
      return observer;
    }
  };
  
  (() => {
    document.addEventListener('alpine:init', () => {
      // Linked Products variant switching
      Alpine.data('LinkedProducts', (type) => ({
        products: [],
        linkedProductsType: '',
        $section: null,
        $products: [],
        init() {
          let am = this;
          am.linkedProductsType = type;
          am.InitSelf();
          subscribe(PUB_SUB_EVENTS.variantChange, Alpine.debounce((e) => {
            // console.log(e, am.$el);
            am.UpdateLinkedProductUrls(e.data.variant.options);
          }));
        },

        InitSelf() {
          let am = this;

          am.$section = am.$el;
          am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];
          // console.log(am.$products);

          // init products on page load
          (async() => {
            let px_products = am.$products.map(($item) => {
              let handle = $item.dataset.linkedProduct;
              return fetch(`/products/${ handle }.js`).then(res => res.json());
            });

            am.products = await Promise.all(px_products);
            // console.log(am.products)
            am.UpdateLinkedProductUrls();
          })();
        },
  
        UpdateLinkedProductUrls(current_values) {
          let am = this;
  
          if (!am.products.length) return;
  
          am.$products.forEach(($product) => {
            let handle = $product.dataset.linkedProduct;
            let product = am.products.find(p => p.handle == handle);
            let color = $product.dataset.value;
            //console.log(color);
            if (!product) return;
  
            if (!current_values) {
              current_values = JSON.parse($product.dataset.current_values);
            }
            const index = 1; 
            current_values[index] = color;
            //console.log(current_values);
            let optionIdsToMatch = [1,2,3];
            if (am.linkedProductsType) {
              // exclude option from matching
              //optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
              //console.log('options to match:'+optionIdsToMatch);
            }
  
            let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id-1)]);
            //console.log('Values to match:'+valuesToMatch);
            let matching_variant = product.variants.find((v) => {
              let v_options = optionIdsToMatch.map((id) => v[`option${ id }`]).join('/');
              return v_options == valuesToMatch.join('/')
            });
            if (!matching_variant) {
              console.error('no matching variant', valuesToMatch);
              return
            };
            //console.log(matching_variant.title)
            $product.setAttribute('href', `/products/${ handle }?variant=${ matching_variant.id }`);
  
            // apply soldout class if not available
            const shapeLabel = $product.querySelector('label')
            if (shapeLabel) {
              shapeLabel.classList.toggle('disabled', !(matching_variant && matching_variant.available));
            }
          });
        }
       }));
  
      // Alpine.data('ProductImages', () => ({
      //   product: null,
      //   image_gallery: [],
      //   $swiper_container: null,
      //   swiper: null,
      //   mq_desktop: window.matchMedia('(min-width: 749px)'),
      //   mounted() {
      //     //console.log('mounted');
      //     let am = this
      //     am.$swiper_container = am.$el.querySelector('.swiper-container')
      //     am.LoadProduct()
  
      //     // add variant change handler, expects a variant object
      //     subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      //       // console.log(e.data.variant.title);
      //       let variant_id = e.data.variant.id
      //       // console.log(variant_id)
      //       am.product.selected_variant = am.product.variants.find(v => v.id == variant_id)
      //       // console.log(am.product.selected_variant)
      //       am.SetGalleryImages()
      //       //window.scrollTo(0,0)
      //     })
  
      //     am.mq_desktop.addEventListener('change', am.UpdateSwiper.bind(am))
      //   },
      //   LoadProduct() {
      //     let am = this
      //     UTILS.ConvertStringToJS(am.$el.querySelector('[data-product-json]').innerHTML)
      //     am.product = product
      //     am.SetGalleryImages()
      //   },
      //   async SetGalleryImages() {
      //     //console.log('Set gallery images')
      //     let am = this
      //     let variant_images = am.product.selected_variant.mf.image_gallery || [am.product.selected_variant.media]
      //     let image_gallery = [...variant_images]
  
      //     // // preload first image and render
      //     // let images = [image_gallery[0]].map(async(item) => {
      //     //   let img = new Image()
      //     //   img.src = item.preview_image.src + '?&width=960'
      //     //   await img.decode()
      //     //   return img
      //     // })
      //     // load images for caching and then render
      //    // await UTILS.PromisesSequential(images)
      //     // console.log(image_gallery)
      //     am.image_gallery = image_gallery
      //     am.$nextTick(am.UpdateSwiper.bind(am))
      //   },
      //   UpdateSwiper() {
      //     let am = this
      //     if (am.mq_desktop.matches) {
      //       // no swiper on desktop
      //       if (am.swiper) {
      //         am.$swiper_container.classList.add('swiper-off')
      //         am.swiper.destroy()
      //         am.swiper = null
      //       }
      //     }
      //     else {
      //       // init swiper on mobile
      //       //console.log('mobile init')
      //       let $swiper_container = am.$swiper_container
      //       let initialSlide
      //       if (am.swiper) {
      //         initialSlide = am.swiper.activeIndex
      //         am.swiper.destroy()
      //       }
      //       am.swiper = new Swiper($swiper_container, {
      //         initialSlide: initialSlide || 0,
      //         slidesPerView: '1.05',
      //         mousewheel: {
      //           invert: false,
      //           forceToAxis: true
      //         },
      //         spaceBetween: '4',
      //         pagination: {
      //           el: am.$el.querySelector('.swiper-pagination'),
      //           type: "fraction",     
      //           clickable: true
      //         },
      //         preventClicksPropagation: false,
      //         preventClicks: false,
      //         navigation: {
      //           nextEl: '.swiper-button-next-custom',
      //           prevEl: '.swiper-button-prev-custom',
      //         },
      //         on: {
      //           init() {
      //             am.$swiper_container.classList.remove('swiper-off')
      //             am.$swiper_container.querySelector('.swiper-nav-custom').style.opacity = 1
      //           }
      //         }
      //       })
      //     }
      //   },
      //   e_OpenZoomModal(e, item) {
      //     console.log(e, item)
      //     console.log('open zoom');
      //     let am = this
      //     //if (!am.mq_desktop.matches) return
          
      //     MicroModal.show('gallery-zoom-modal',{
      //       onShow: function(modal){
      //         document.body.classList.add("overflow-hidden");
      //      },
      //      onClose: function(modal){
      //         document.body.classList.remove("overflow-hidden");
      //      }
      //     })
  
      //     // scroll to position
      //     let $modal_item = document.querySelector(`.mm-modal [data-id="${ item.id }"`)
      //     let $modal_container = document.querySelector('.mm-modal-container')
      //     let offset = 64
      //     if (!$modal_item) return
      //     $modal_container.style.setProperty('--modal-height', `${ ($modal_item.offsetHeight + offset) }px`)
      //     $modal_container.scrollTo({
      //       top: $modal_item.offsetTop - offset
      //     })
      //   },
      //   GetImageSrcsetLarge(src) {
      //     return `${ src }&width=550 550w, ${ src }&width=600 1100w, ${ src }&width=750 1445w, ${ src }&width=960 2048w`
      //   },
      //   GetImageSrcset(src) {
      //     return `${ src }&width=550 550w, ${ src }&width=400 1100w, ${ src }&width=400 1445w, ${ src }&width=400 2048w`
      //   },
      //   GetImageSrcsetZoom(src) {
      //     return `${ src }&width=550 550w, ${ src }&width=1100 1100w, ${ src }&width=1445 1445w, ${ src }&width=1600 2048w`
      //   },
      //   GetImageUrl(src, width) {
      //     return `${ src }&width=${ width }`
      //   },
      //   GetVideoSource(item) {
      //     let item_video = item.sources.find(src => src.height == '1080' && src.mime_type == 'video/mp4')
      //     return item_video ? item_video.url : ''
      //   }
      // }))
     
  
      // Alpine.data('LifestyleContent', () => ({
      //   product: null,
      //   lifestyle_image: null,
      //   hasLifestyleImage: false,
      //   mounted() {
      //     //console.log('mounted lifestyle content');
      //     let am = this
      //     am.LoadProduct()
  
      //     // add variant change handler, expects a variant object
      //     subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      //       let variant_id = e.data.variant.id
      //       am.product.selected_variant = am.product.variants.find(v => v.id == variant_id)
      //       am.SetLifestyleContent()
      //     })
      //   },
      //   LoadProduct() {
      //     let am = this
      //     UTILS.ConvertStringToJS(am.$el.querySelector('[data-product-json]').innerHTML)
      //     am.product = product
      //     //console.log('product:: ', product)
      //     am.SetLifestyleContent()
      //   },
      //   SetLifestyleContent() {
      //     let am = this
      //     //console.log('set lifestyle content');
      //     let variant_desc = am.product.selected_variant.mf.color_description
      //     let image = am.product.selected_variant.mf.color_description_image
    
      //     am.lifestyle_image = image
      //     am.variant_desc = variant_desc
          
      //     am.lifestyle_image ? am.hasLifestyleImage = true : am.hasLifestyleImage = false;
      //   },
      //   GetImageSrcset(src) {
      //     return `${ src }&width=550 550w, ${ src }&width=1100 1100w, ${ src }&width=1445 1445w, ${ src }&width=2048 2048w`
      //   },
      //   GetImageUrl(src, width) {
      //     return `${ src }&width=${ width }`
      //   }
        
      // }))

      // Alpine.data('VariantLabel', () => ({
      //   product: null,
      //   variant_label: null,
      //   mounted() {
      //     console.log('mounted variant label');
      //     let am = this
      //     am.LoadProduct()
  
      //     // add variant change handler, expects a variant object
      //     subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      //       let variant_id = e.data.variant.id
      //       am.product.selected_variant = am.product.variants.find(v => v.id == variant_id)
      //       am.SetVariantLabel()
      //     })
      //   },
      //   LoadProduct() {
      //     let am = this
      //     UTILS.ConvertStringToJS(am.$el.querySelector('[data-product-json]').innerHTML)
      //     am.product = product
      //     am.SetVariantLabel()
      //   },
      //   SetVariantLabel() {
      //     let am = this
      //     let variant_label = am.product.selected_variant.mf.color_label
      //     let variant_label_color = am.product.selected_variant.mf.color_label_color
      //     let color_label_bold = am.product.selected_variant.mf.color_label_bold
      //     let color_label_italic = am.product.selected_variant.mf.color_label_italic
      //     if (variant_label != null){
      //     var p_class = 'product-grid-message tw-normal-case !-tw-my-2 tw-font-main'
      //     var p_style = ''
      //     if (color_label_bold == 'true'){
      //       p_class += ' tw-font-bold';
      //     }
      //     if (color_label_italic == 'true'){
      //       p_class += ' tw-italic';
      //     }
      //     if (variant_label_color.length != 0){
      //       p_style += 'style="color:'+ variant_label_color+';"';
      //     }
          
      //     am.variant_label = '<p class="'+p_class+'"' + p_style + '>' +
      //     variant_label
      //     '</p>';
      //     }
      //   }
        
      // }))
  
      
  
      // Alpine.data('GalleryVideo', () => ({
      //   mounted() {
      //     let am = this
      //     UTILS.ObserveIntersection(am.$el, {}, (entries) => {
      //       let entry = entries[0]
      //       let video = entry.target
      //       video.muted = true
      //       video[entry.isIntersecting ? 'play' : 'pause']()
      //     })
      //   }
      // }))

    })
  })()